import { render, staticRenderFns } from "./GenericWindow.vue?vue&type=template&id=1650bcb3&scoped=true&"
import script from "./GenericWindow.vue?vue&type=script&lang=js&"
export * from "./GenericWindow.vue?vue&type=script&lang=js&"
import style0 from "./GenericWindow.vue?vue&type=style&index=0&id=1650bcb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1650bcb3",
  null
  
)

export default component.exports